/**
 * Framework
 */
var dom = {
	getAll: function(query) {
		return document.querySelectorAll(query);
	},
	getById: function(idName) {
		return document.getElementById(idName);
	},
	getChildByClass: function(parentEl, childClassName) {
		var node = parentEl.firstChild;
		while(node) {
			if( this.hasClass(node, childClassName) ) {
				return node;
			}
			node = node.nextSibling;
		}
	},
	remove: function(el) {
		el.parentNode.removeChild(el);
	},
	removeClass: function(el, className) {
		var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, ''); 
	},
	addClass: function(el, className) {
		if( !this.hasClass(el,className) ) {
			el.className += (el.className ? ' ' : '') + className;
		}
	},
	toggleClass: function(el, className) {
		if (this.hasClass(el,className)) {
			this.removeClass(el,className); 
			return;
		}
		this.addClass(el,className);
	},
	hasClass: function(el, className) {
		return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
	},
	get: function(url, callback) {
		var httpRequest = new XMLHttpRequest();
		httpRequest.onreadystatechange = function () {
			if (httpRequest.readyState == 4) {
				if (httpRequest.status == 200){
					if(callback)
						callback(JSON.parse(httpRequest.responseText));
				}
			}
		}
		httpRequest.open('GET', url);
		httpRequest.send();
	},
	extend: function(o1, o2, preventOverwrite) {
		for (var prop in o2) {
			if (o2.hasOwnProperty(prop)) {
				if(preventOverwrite && o1.hasOwnProperty(prop)) {
					continue;
				}
				o1[prop] = o2[prop];
			}
		}
	},

	has3d: function() {
		if (!window.getComputedStyle) {
		    return false;
		}

		var el = document.createElement('p'), 
		    has3d,
		    transforms = {
		        'webkitTransform':'-webkit-transform',
		        'OTransform':'-o-transform',
		        'msTransform':'-ms-transform',
		        'MozTransform':'-moz-transform',
		        'transform':'transform'
		    };

		// Add it to the body to get the computed style.
		document.body.insertBefore(el, null);

		for (var t in transforms) {
		    if (el.style[t] !== undefined) {
		        el.style[t] = "translate3d(1px,1px,1px)";
		        has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
		    }
		}

		document.body.removeChild(el);

		return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
	},

	translate: function(element, x, y, z)
	{
		var transformName =  this.has3d() ? 'translate3d' : 'translate';
		var transform = this.has3d() ? '('+ x+'px, '+ y+'px, '+ 0+'px) scale('+z+')' : '('+ x+'px, ' + y+'px) scale('+z+')';

		function _transform(e, t) {
			e.style.msTransform = t; // IE9
			e.style.MozTransform = t;
			e.style.webkitTransform = t;
			e.style.transform = t;
		}

		_transform(element, transformName+''+transform+'');
	},

	css: function(element){
		if(!window.getComputedStyle){
			return false;
		}

		return window.getComputedStyle(element);
	},

	setCss: function(elems, propName, propVal){
		if( Object.prototype.toString.call(elems) === '[object Array]' ) {
			for(var i = 0, len = elems.length; i < len; i++){
				var elem = elems[i];
				elem.style[propName] = propVal;
			}
		}else{
			if(typeof elems !== 'undefined' && elems){
				elems.style[propName] = propVal;
			}
		}
	},

	debounce: function (func, wait, immediate) {
		// Returns a function, that, as long as it continues to be invoked, will not
		// be triggered. The function will be called after it stops being called for
		// N milliseconds. If `immediate` is passed, trigger the function on the
		// leading edge, instead of the trailing.
		var timeout;

		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},

	getClosest: function ( elem, selector ) {

		// Element.matches() polyfill
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function(s) {
					var matches = (this.document || this.ownerDocument).querySelectorAll(s),
						i = matches.length;
					while (--i >= 0 && matches.item(i) !== this) {}
					return i > -1;
				};
		}

		// Get closest match
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( typeof elem.matches !== 'undefined' && elem.matches( selector ) ) return elem;
		}

		return null;

	}
}


/** Mobile Detect */

//var md = new MobileDetect(window.navigator.userAgent);

/** Ajax */

var ajax = {};
ajax.x = function() {
    if (typeof XMLHttpRequest !== 'undefined') {
        return new XMLHttpRequest();  
    }
    var versions = [
        "MSXML2.XmlHttp.6.0",
        "MSXML2.XmlHttp.5.0",   
        "MSXML2.XmlHttp.4.0",  
        "MSXML2.XmlHttp.3.0",   
        "MSXML2.XmlHttp.2.0",  
        "Microsoft.XmlHttp"
    ];

    var xhr;
    for(var i = 0; i < versions.length; i++) {  
        try {  
            xhr = new ActiveXObject(versions[i]);  
            break;  
        } catch (e) {
        }  
    }
    return xhr;
};

ajax.send = function(url, callback, method, data, sync) {
    var x = ajax.x();
    x.open(method, url, sync);
    x.onreadystatechange = function() {
        if (x.readyState == 4) {
        	if (x.status == 200)
            	callback(x.responseText);
        }
    };
    if (method == 'POST') {
        x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    x.send(data)
};

ajax.get = function(url, data, callback, sync) {
    var query = [];
    for (var key in data) {
        query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    }
    ajax.send(url + (query.length ? '?' + query.join('&') : ''), callback, 'GET', null, sync)
};

ajax.post = function(url, data, callback, sync) {
    var query = [];
    for (var key in data) {
        query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    }
    ajax.send(url, callback, 'POST', query.join('&'), sync)
};


/* Validate */

var is = {
	email: function(e) {
		var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    	return re.test(e);
	}
};